import './App.css';
import './Anasayfa'
import React from 'react';
import ReactDOM from 'react-dom';
import Anasayfa from './Anasayfa';
import { LanguageProvider } from './LanguageContext';
import { useEffect } from "react";
import TagManager from "react-gtm-module";


const tagManagerArgs = {
  gtmId: "GTM-5QVK39TG",
};


function App() {
  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <div className="App">
     <LanguageProvider>
    <Anasayfa/>
    </LanguageProvider>
   
    </div>
  );
}

export default App;
